import { useMutation, useQueryClient } from '@tanstack/react-query';
import { projectVolumesKeys } from '../../../../hooks/useProjectVolumes';
import { projectDataClient } from '../../../../lib/connect/clients';
export function useCreateResponseArtifact(projectId) {
    const cache = useQueryClient();
    return useMutation({
        mutationFn: async (input)=>{
            const result = await projectDataClient.createCustomVolume({
                projectId,
                ...input
            });
            if (!result.volume) throw new Error('The volume was not returned. Reload before trying again.');
            return result.volume;
        },
        onSuccess: ()=>cache.invalidateQueries({
                queryKey: projectVolumesKeys.list(projectId)
            })
    });
}
export function useReorderProposalVolumes(projectId) {
    const cache = useQueryClient();
    return useMutation({
        mutationFn: (volumeIds)=>projectDataClient.reorderProposalVolumes({
                projectId,
                volumeIds
            }),
        // ListVolumes supplies document/source enrichment missing from the reorder reply.
        onSettled: ()=>cache.invalidateQueries({
                queryKey: projectVolumesKeys.list(projectId)
            })
    });
}
